<template>
  <div class="upper">
    <label>YOU'RE NOT ALONE</label>
    <h3 v-if="collegeHasCrisisPhoneFeature">24/7 On-Demand Emotional Support and Crisis Resources</h3>
    <h3 v-else>24/7 Crisis Resources</h3>
  </div>
</template>

<script>
export default {
  name: 'CrisisHeader',
  props: {
    collegeHasCrisisPhoneFeature: {
      type: Boolean,
      required: true,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  @include label;

  display: inline-block;
  margin-bottom: 15px;
}
</style>
